// src/com/tsr/TsrPrintFresh.js
import React, {useEffect} from 'react';
import TopHomeplusPng from '../../asset/image/top_homeplus.png';
import {
    tsrDateTime, tsrLetter, tsrNumber, TsrPageStyle, TsrStyles, tsrTemperature
} from './TsrStyle';

export default function TsrPrintFresh({tsrData}) {
    const printedRef = React.useRef(false);

    useEffect(() => {
        //document.body.style = import('../../asset/css/NT_TrailerSeal.css');
        document.title = "(FDC)TSR 장표발행";
    }, []);
    
    useEffect(()=>{
        if(tsrData.storeId && !printedRef.current) {
            window.print();
            printedRef.current = true;
        }
    }, [tsrData]);
    
    const renderSeal = (sealNo) => {
        return (
            <ol className="seal_box">
                {
                    Array.from({length: 5}, (v, k) => k).map((idx) => {
                        return <li key={idx}>{tsrLetter(sealNo,idx)}</li>
                    })
                }
            </ol>
        );
    };

    return (
        // <div size="A4" style={TsrPageStyle}>
        <div size="A4" className="tsr-print-page tsr-print-page--fresh" style={TsrPageStyle}>
            {/* <!-- 타이틀 --> */}
            <div class="tsr_title" style={{verticalAlign: 'bottom'}}>
                <div style={{width: '50mm'}}><img alt="홈플러스 로고" src={TopHomeplusPng} style={{width:'100px'}}/></div>
                <div class="text_trailer" style={{width:'100mm', textAlign:'center'}}>TRAILER SEAL RECORD</div>
                <div class="border_box" style={{width:'55mm', height:'4mm'}}>배차구분 : {tsrData.transType}</div>
            </div>
            {/* <!-- 헤더 (출발지)  --> */}
            <div class="tsr_box" style={TsrStyles.noTopMargin}>
                <div class="red_box" style={{
                    width: '50mm',
                    height: '5mm',
                    fontSize: '16px',
                    verticalAlign: 'middle',
                }}>출발지: {tsrData.dcName}</div>
                <div class="border_box" style={{
                    width: '83mm',
                    height: '5mm',
                    borderColor: '#1064e5',
                    textAlign: 'center',
                }}>오배송 주의 : 출발 전 점포명과 주소 확인하여<br/>다른 점포로 배송되는 일이 없도록 당부 부탁드립니다.</div>
                <div class="border_box" style={{width:'65mm', height:'5mm'}}>상차완료 : {tsrDateTime(tsrData.loadEnTime)}</div>
            </div>
            {/* <!-- 헤더 (도착지) --> */}
            <div class="tsr_box" style={TsrStyles.noTopMargin}>
                <div class="black_box" style={{
                    width: '50mm', height: '12mm', display: 'inline-table',
                }}><div class="arrive_text">{tsrData.storeName}</div></div>
                <div class="black_box" style={{
                    width: '20mm', height: '12mm', display: 'inline-table',
                }}><div class="arrive_text">{tsrData.hocha} 호</div></div>
                <div class="border_box" style={TsrStyles.div60x4}>차량번호 : {tsrData.vehPlates}</div>
                <div class="border_box" style={TsrStyles.div65x4}>출발예정 : {tsrDateTime(tsrData.prosDptrTime)}</div>
                <div class="border_box" style={TsrStyles.div60x4}>운행기사 : {tsrData.driverName}</div>
                <div class="black_box" style={TsrStyles.div65x4}>도착예정 : {tsrDateTime(tsrData.prosArrTime)}</div>
            </div>

            {/* <!-- 주소 / 전화번호   --> */}
            <div class="tsr_box">
                도착지 주소 : {tsrData.storeAddr}
            </div>
            <div style={{fontSize:'13px'}}>
                전화번호 : {tsrData.storeOfficeTelno}
            </div>

            {/* <!-- 봉인번호  --> */}
            <div class="tsr_box tsr_sub_t">
                <div class="tsr_sub_t_text">■ 봉인번호(Seal Number)</div>
                <div class="tsr_sub_t_box">
                    {tsrData.bindStores ? tsrData.bindStores.map((store) => store.storeName).join(">>"):null}
                </div>
                <div style={{width:'145mm', marginTop:'1mm'}}>
                    {renderSeal(tsrData.sealNo1)}
                    {renderSeal(tsrData.sealNo2)}
                    {renderSeal(tsrData.sealNo3)}
                    <div class="dot_box"><span>봉인부착</span></div>
                    <div class="dot_box"><span>봉인부착</span></div>
                    <div class="dot_box"><span>봉인부착</span></div>
                </div>
                {/* <!-- 점포명 / 봉인번호 확인 서명 --> */}
                <div style={TsrStyles.width60mm}>
                    <div class="tsr_sub_t_text">■ 점포명/봉인번호 확인 서명</div>
                    <div class="border_box" style={{height:'19mm'}}><br/>
                        운행기사 : <div style={{borderBottom:'1px solid', width:'31mm'}}></div>&nbsp;(서명)<br/><br/><br/>
                        점포담당 : <div style={{borderBottom:'1px solid', width:'31mm'}}></div>&nbsp;(서명)
                    </div>
                </div>
                <div style={{textAlign: 'center', marginTop: '2mm'}}>
                    ※ 봉인 개봉 전 점포명과 봉인번호를 다시 한번 확인하시기 바라며 이상 없을 시 서명하여 주시기 바랍니다.
                </div>
            </div>

            <div class="tsr_box" style={TsrStyles.noTopMargin}>
                <div style={{width:'165mm', marginTop:'0mm'}}>
                    {/* <!-- 물류집기 출고 현황 --> */}
                    <div class="tsr_sub_t_text">■ 물류집기 출고 현황</div>
                    <table class="out_f_table" style={TsrStyles.topMargin2mm}>
                        <tr>
                            <td style={{width:'20mm'}}>격실구분</td>
                            <td colspan="2">전면</td>
                            <td colspan="2">중면</td>
                            <td colspan="2">후면</td>
                            <td colspan="2" rowspan="2">기타 Pallet</td>
                            <td colspan="2" rowspan="2">Shroud<br/>(보냉커버)</td>
                            <td rowspan="3">NJC</td>
                            <td rowspan="3">우든<br/>칼라</td>
                            <td rowspan="3">옥타곤</td>
                            <td rowspan="3">싱글트레이</td>
                        </tr>
                        <tr>
                            <td>출발온도</td>
                            <td colspan="2" class="out_f_text">{tsrTemperature(tsrData.tempF)}</td>
                            <td colspan="2" class="out_f_text">{tsrTemperature(tsrData.tempM)}</td>
                            <td colspan="2" class="out_f_text">{tsrTemperature(tsrData.tempR)}</td>
                        </tr>
                        <tr>
                            <td>물류집기</td>
                            <td>KPP</td>
                            <td>AJU</td>
                            <td>KPP</td>
                            <td>AJU</td>
                            <td>KPP</td>
                            <td>AJU</td>
                            <td>KPP</td>
                            <td>AJU</td>
                            <td>Full</td>
                            <td>Half</td>
                        </tr>
                        <tr>
                            <td style={{height:'11mm'}}>상차수량</td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fFPalKpp)}</td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fFPalAju)}</td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fMPalKpp)}</td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fMPalAju)}</td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fRPalKpp)}</td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fRPalAju)}</td>
                            <td class="t_td_cell">
                                {tsrNumber(tsrData.fFEtcKpp + tsrData.fMEtcKpp + tsrData.fREtcKpp)}
                            </td>
                            <td class="t_td_cell">
                                {tsrNumber(tsrData.fFEtcAju + tsrData.fMEtcAju + tsrData.fREtcAju)}
                            </td>
                            <td class="t_td_cell">
                                {tsrNumber(tsrData.fFShrFull + tsrData.fMShrFull + tsrData.fRShrFull)}
                            </td>
                            <td class="t_td_cell">
                                {tsrNumber(tsrData.fFShrHalf + tsrData.fMShrHalf + tsrData.fRShrHalf)}
                            </td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fNjc)}</td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fUcolor)}</td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fOctagon)}</td>
                            <td class="t_td_cell">{tsrNumber(tsrData.fTray)}</td>
                        </tr>
                    </table>
                </div>
                
                {/* <!-- 상차정보--> */}
                <div style={{width:'40mm', marginTop:'0mm'}}>
                    <div class="tsr_sub_t_text" style={{marginBottom:'1mm', width:'30mm'}}>■ 상차정보</div><br/>
                    ．<div class="up_info_text" style={{width:'13mm'}}>Wave:</div><div class="underbar_line" style={{width:'22mm', textAlign:'left'}}>{tsrData.transType}</div><br/>
                    ．BOL Number<br/>
                    <div class="border_box" style={{width:'38mm', height:'4mm'}}>{tsrData.bol1}</div>
                    <div class="border_box" style={{width:'38mm', height:'4mm'}}>{tsrData.bol2}</div>
                    <div class="border_box" style={{width:'38mm', height:'4mm'}}>{tsrData.bol3}</div>
                </div>
            </div>


            <div class="tsr_box">
                {/* <!-- 비고 --> */}
                <div style={{width:'209mm'}}>
                    <div class="tsr_sub_t_text" style={{ width: '25mm', height: '4mm', float: 'left', }}>■ 비고</div>
                    <div class="border_box" style={{ width: '178mm', height: '4mm', }}>{tsrData.note}</div>
                    <div class="tsr_sub_t_text" style={{width: '25mm',height: '10mm',float: 'left',}}>■ 특이사항</div>
                    <div class="border_box" style={{width: '178mm',height: '10mm'}}>{tsrData.memo}</div>
                </div>	
            </div>

            {/* <!-- transport Manager / Operation Manager / 상차작업자 --> */}
            <div class="tsr_box">
                <div class="tsr_sub_t_text" style={{width:'44mm'}}>■ Transport Manager:</div>
                <div class="underbar_line" style={TsrStyles.width25mm}>{tsrData.dcTransStaffName}</div>
                <div class="tsr_sub_t_text" style={{width:'44mm'}}>■ Operation Manager:</div>
                <div class="underbar_line" style={TsrStyles.width25mm}>{tsrData.dcOperStaffName}</div>
                <div class="tsr_sub_t_text" style={{width:'31mm'}}>■ 상차 작업자:</div>
                <div class="underbar_line" style={TsrStyles.width25mm}>{tsrData.loadStaffName}</div> (서명)
            </div>

            {/* <!-- 도착지 수기 입력 --> */}
            <div class="tsr_box border_box" style={{width: '205mm',marginTop: '2mm'}}>
                {/* <!-- 도착지 명 --> */}
                <div style={{width: '147mm', marginTop: '0mm'}}>
                    <div class="black_box" style={{
                        width: '60mm',
                        fontSize: '19px',
                        verticalAlign: 'middle',
                        padding: '3mm',
                        fontWeight: 'bold',
                    }}>도착지: {tsrData.storeName}</div>
                    {/* <!-- 격실구분 / 도착 온도 --> */}
                    <table class="arrive_f_table" style={TsrStyles.topMargin2mm}>
                        <tr>
                            <td>격실구분</td>
                            <td>전면</td>
                            <td>중면</td>
                            <td>후면</td>
                        </tr>
                        <tr>
                            <td>도착온도</td>
                            <td class="value_td">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;℃</td>
                            <td class="value_td">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;℃</td>
                            <td class="value_td">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;℃</td>
                        </tr>
                    </table>
                    
                    {/* <!-- 운송차량 시간/ 물류집기 반납현황 --> */}
                    <table class="state_table" style={TsrStyles.topMargin2mm}>
                        <tr>
                            <td rowspan="2" colspan="2">운송차량 시간관리</td>
                            <td colspan="9">물류집기 반납현황</td>
                        </tr>
                        <tr>
                            <td colspan="2">Pallet</td>
                            <td colspan="2">Shroud</td>
                            <td colspan="3">기타</td>
                            <td colspan="2">집기적재 Pallet</td>
                        </tr>
                        <tr>
                            <td style={{width:'19mm'}}>점포<br/>도착시간</td>
                            <td style={{width:'19mm'}}>점포<br/>출발시간</td>
                            <td>KPP</td>
                            <td>AJU</td>
                            <td>Full</td>
                            <td>Half</td>
                            <td>NJC</td>
                            <td>우든<br/>칼라</td>
                            <td>옥타곤</td>
                            <td>KPP</td>
                            <td>AJU</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                    
                    <div class="blue_box" style={TsrStyles.topMargin2mm}>
                        <label>■ AJU pallet, NJC는 안성 또는 밀양 물류서비스 센터로 반납하시기 바랍니다.</label><br/>
                        <label>■ 집기반납 시 NJC 집기는 AJU pallet, KCP 집기는 KPP pallet를 이용하여 주시기 바랍니다.</label><br/>
                        <label>■ 물류집기 반납수량은 운송운영 프로그램에 입력하여 주시기 바랍니다.</label>
                    </div>
                    {/* <!-- 정보 --> */}
                    <div class="tsr_info" style={TsrStyles.topMargin2mm}>
                        <label style={TsrStyles.topMargin1mm}>1.봉인(Seal) 개봉 전 봉인번호를 다시 한번 확인하시기 바랍니다.</label><br/>
                        <label style={TsrStyles.topMargin1mm}>2.점포 도착온도, 도착시간, 출발시간을 정확히 기록하여 주시기 바랍니다.</label><br/>
                        <label style={TsrStyles.topMargin1mm}>3.점포 담당자께서는 물류집기 및 반품 상차 시 운송기사의 확인 서명을 받으시기 바랍니다.</label>
                    </div>
                </div>
                
                {/* <!-- 출발 봉인번호 "width:55mm; margin-top:2mm;margin-left:2mm;" --> */}
                <div style={{width: '55mm',marginTop: '2mm',marginLeft: '2mm'}}>
                    <div class="tsr_sub_t_text">■ 출발 봉인번호</div>
                    <ol class="seal_box" style={TsrStyles.topMargin2mm}><li></li><li></li><li></li><li></li><li></li></ol>
                    <div class="dot_box"><span>봉인부착</span></div>
                </div>
                
                {/* <!-- 특이사항 --> */}
                <div style={{width: '55mm',marginTop: '2mm',marginLeft: '2mm'}}>
                    <div class="tsr_sub_t_text">■ 특이사항</div>
                    <div class="underbar_line" style={{textAlign: 'right', height: '4mm'}}></div>
                    <div class="underbar_line" style={{textAlign: 'right', height: '4mm'}}></div>
                    <div class="underbar_line" style={{textAlign: 'right', height: '4mm'}}></div>
                </div>
                    
                {/* <!-- 운행기사/ 점포담당자 사인  --> */}
                <div style={{width: '55mm',marginTop: '4mm',marginLeft: '2mm'}}>
                    운행기사 : <div class="underbar_line" style={{width:'28mm',height:'4mm'}}></div>(서명)<br/><br/>
                    점포담당 : <div class="underbar_line" style={{width:'28mm',height:'4mm'}}></div>(서명)
                </div>
            </div>

            <div style={{ textAlign: 'left', marginTop: '2mm', marginLeft: '6mm', width: '200mm' }}>
                ※ 상기 명시된 운송기사는 운송 중 적재물의 분실, 파손, 화재등 일체의 피해와 정비불량 등으로 인한 입고지연 및 안전사고 발생 시<br/>
                지체 없이 운송부서로 연락하여야 합니다. 
            </div>

            <div>
                <div class="tsr_sub_t_text" style={TsrStyles.width65mm}>■ 운송사 : {tsrData.comName}</div>
                <div class="tsr_sub_t_text" style={TsrStyles.width60mm}>소장 : {tsrData.comAgentName} {tsrData.comOfficeTel}</div>
                <div class="tsr_sub_t_text" style={TsrStyles.width80mm}>■ 통합운송센터 : {tsrData.dcStaffName}             {tsrData.dcOfficeTelno}</div>
                <div class="tsr_sub_t_text" style={TsrStyles.width60mm}>■ 도착지 : {tsrData.storeName}</div>
                <div class="tsr_sub_t_text" style={TsrStyles.width60mm}>사무실 : {tsrData.storeStaffName} {tsrData.storeOfficeTelno}</div>
                <div class="tsr_sub_t_text" style={TsrStyles.width60mm}>보안실 : {tsrData.storeSecuTelno}</div>
            </div>
        </div>
    );
}